import Vue from "vue";
import {ActionTree, Module, Store} from "vuex";
import store, {RootState} from "../store";


export class HikeMapState {

}

const state = new HikeMapState()

const actions: ActionTree<HikeMapState, RootState> = {

}


const mutations = {

}

const getters = {

};

const modules = {

}

export default class HikeMapModule implements Module<HikeMapState, RootState> {
  namespaced = true
  state = state
  actions = actions
  mutations = mutations
  getters = getters
  modules = modules
}
